import React from 'react';
import { useIntl } from 'react-intl-next';
import { ProformaIntlProvider } from '@atlassian/proforma-utils/intl-provider';
import jsmAttachmentLazyMessages from '../../../i18n/lazy';
export var PackageIntlProvider = function PackageIntlProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  return /*#__PURE__*/React.createElement(ProformaIntlProvider, {
    locale: locale,
    messages: jsmAttachmentLazyMessages
  }, children);
};

/**
 * This is a simple HoC wrapper for PackageIntlProvider.
 */
export var withPackageIntlProvider = function withPackageIntlProvider(WrappedComponent) {
  return function (props) {
    var intl = useIntl();
    return /*#__PURE__*/React.createElement(PackageIntlProvider, {
      locale: intl.locale
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
};